import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardSlider, Toggle, Modal, CARD_SLIDER_CARD_SIZES
} from 'day8-react/build/new-components';

const Itinerary = ({ days }) => (
  <Fragment>
    {days && days.length > 0 ? (
      <Fragment>
        <h2 className="d8-u-ls-sm margin-bottom-md text-center">Example Itinerary</h2>
        <CardSlider cardSize={CARD_SLIDER_CARD_SIZES.XS_WIDE}>
          {days.map((day, i) => (
            <Toggle key={JSON.stringify(day)}>
              {({ toggle, on }) => (
                <Fragment>
                  <Card
                    template="ImageCard"
                    imageCardTemplate="VerticalSplit"
                    mainTitle={day.title?.rendered}
                    heading={`Day ${i + 1}`}
                    image={{ url: day.featured_image_src, alt: day.title?.rendered }}
                    size="xl"
                    onClick={toggle}
                  />
                  <Modal style={{ width: 'var(--max-width-xxs)', minWidth: 'unset' }} template="MediaModal" on={on} toggle={toggle} title={day.title?.rendered.replace(/<[^>]*>/g, '')} text={day && day.content && day.content.rendered && day.content.rendered.replace(/<[^>]*>/g, '')} image={{ url: day.featured_image_src, alt: day.title?.rendered.replace(/<[^>]*>/g, '') }} />
                </Fragment>
              )}
            </Toggle>
          ))}
        </CardSlider>
      </Fragment>
    ) : (
      <div className="max-width-xxxxs margin-auto text-center">
        <Card
          className="option-left"
          bgColor="d8-u-white-bg"
          heading="COMING SOON"
          topText="Itinerary"
          subheading="We're busy preparing an amazing itinerary for this event, check back soon!"
        />
      </div>
    )}
  </Fragment>
);
Itinerary.propTypes = {
  days: PropTypes.array
};
export default Itinerary;
